<template>
  <e-card @toggleDrag="$emit('toggleDrag')" :class="sizeClasses" class="assets-list-wizard" data-v-step="4">
    <b-tab title="Crypto" class="e-card__content">
      <b-table responsive @row-clicked="rowClicked" v-if="!$wait.is('assets.fetchSectors') && isLoaded" hover class="e-table e-table--bg--white e-table--padding--small" :fields="assetsListTableFields" :items="assets">
        <template slot="HEAD_project" slot-scope="data">
          Projects
        </template>
        <template slot="HEAD_sector" slot-scope="data">
          Sector
        </template>
        <template slot="HEAD_rates" slot-scope="data">
          Rates
        </template>
        <template slot="HEAD_rate" slot-scope="data">
          Score
        </template>
        <template slot="HEAD_actions" slot-scope="data">
          Actions
        </template>
        <template slot="project" slot-scope="data">
          <div class="d-flex align-items-center">
            <div class="e-avatar size-30 mr-4">
              <img :src="data.item.logoPath">
            </div>
            <div class="d-flex flex-column">
              <b>{{ data.item.name }}</b>
              <span>{{ data.item.symbol }}</span>              
            </div>
          </div>
        </template>
        <template slot="sector" slot-scope="data">
          {{ flattenSector(data.item.sectors, data.item) | shortText }}
        </template>
        <template slot="rates" slot-scope="data">
          <b>{{ data.item.totalRaters }}</b> / {{ data.item.totalModerations || 0 }}
        </template>
        <template slot="rate" slot-scope="data">
          <p class="text-center">{{ data.item.rate === 0 ? 'N/A' : data.item.rate }} {{ data.item.rate === 0 ? '' : `(${convertRate(data.item.rate)})` }}</p>
        </template>
        <template slot="actions" slot-scope="data">
          <div class="d-flex flex-row">
            <e-button type="outlined" color="blue-light" size="smaller" class="px-3" :data-v-step="data.index === 0 ? 5 : null" @click="(e) => onRateClick(data.item, e)">Rate</e-button>
            <e-button type="outlined" color="blue-light" size="smaller" class="ml-3 px-3" :data-v-step="data.index === 0 ? 6 : null" @click="(e) => onModerateClick(data.item, e)">Moderate</e-button>
          </div>
        </template>
      </b-table>
      <button class='e-btn see-all' @click="onSeeAllClick('crypto')">See All</button>
    </b-tab>
    <b-tab title="Stock" class="e-card__content">
      <b-table responsive @row-clicked="rowClicked" v-if="!$wait.is('assets.fetchSectors') && isLoaded" hover class="e-table e-table--bg--white e-table--padding--small" :fields="assetsListTableFields" :items="assetsStock">
        <template slot="HEAD_project" slot-scope="data">
          Projects
        </template>
        <template slot="HEAD_sector" slot-scope="data">
          Sector
        </template>
        <template slot="HEAD_rates" slot-scope="data">
          Rates
        </template>
        <template slot="HEAD_rate" slot-scope="data">
          Score
        </template>
        <template slot="HEAD_actions" slot-scope="data">
          Actions
        </template>
        <template slot="project" slot-scope="data">
          <div class="d-flex align-items-center">
            <div class="e-avatar size-30 mr-4">
              <img :src="data.item.logoPath">
            </div>
            <div class="d-flex flex-column">
              <b>{{ data.item.name }}</b>
              <span>{{ data.item.symbol }}</span>
            </div>
          </div>
        </template>
        <template slot="sector" slot-scope="data">
          {{ flattenSector(data.item.sectors, data.item) | shortText }}
        </template>
        <template slot="rates" slot-scope="data">
          <b>{{ data.item.totalRaters }}</b> / {{ data.item.totalModerations || 0 }}
        </template>
        <template slot="rate" slot-scope="data">
          <p class="text-center">{{ data.item.rate === 0 ? 'N/A' : data.item.rate }} {{ data.item.rate === 0 ? '' : `(${convertRate(data.item.rate)})` }}</p>
        </template>
        <template slot="actions" slot-scope="data">
          <div class="d-flex flex-row">
            <e-button type="outlined" color="blue-light" size="smaller" class="px-3" :data-v-step="data.index === 0 ? 5 : null" @click="(e) => onRateClick(data.item, e)">Rate</e-button>
            <e-button type="outlined" color="blue-light" size="smaller" class="ml-3 px-3" :data-v-step="data.index === 0 ? 6 : null" @click="(e) => onModerateClick(data.item, e)">Moderate</e-button>
          </div>
        </template>
      </b-table>
      <button class='e-btn see-all' @click="onSeeAllClick('stock')">See All</button>
    </b-tab>
  </e-card>
</template>

<script>
  import ECard from '../../elements/card/card';
  import EbMyAssets from "@components/widgets/myAssets/myAssets";
  import DynamicSizeMixin from '../../../mixins/dynamicSize';
  import _ from 'lodash';
  import { mapGetters, mapActions, mapState } from "vuex";
  import {convertRateToEmixtier} from "../../../utils/assets";
  import Services from '../../../services';
  

  const COLORS = {
    crypto: 'green',
    ico: 'lime-green',
    stock: 'blue',
    ipo: 'cyan',
    startup: 'violet',
  };

  export default {
		name: "ec-assets-list",
    mixins: [DynamicSizeMixin],
    components: {ECard},
    filters: {
      shortText(value) {
		    if(value.length > 25) {
          value = value.substring(0, 22) + '...'
        }

        return value
      }
    },
    data() {
      return {
        currentAssetId: null,
        assets: [],
        assetsStock: [],
        isLoaded: false,
        assetsListTableFields: [
          'project', 'sector', 'rates', 'rate', 'actions'
        ],
      };
    },
    methods: {
      ...mapActions('assets', {
        fetchAssetsByFilter: 'fetchAssetsByFilter',
        fetchCriteria: 'fetchCriteria',
        fetchSectors: 'fetchSectors',
      }),
      ...mapActions('ui', {
        'addToDashboard': 'addToDashboard'
      }),
      rowClicked(item, i, e) {    
        this.$router.push({name: 'asset', params: {id: item.id}});
      },
      convertRate(rate) {
        return convertRateToEmixtier(rate);
      },
      onSeeAllClick(type) {
        this.$router.push(`/assets/list?type=${type}`);
      },
      onRateClick(asset, e) {
        e.stopPropagation();
        this.$router.push({name: 'create-rate', params: {alias: asset.id}})
      },
      onModerateClick(asset, e) {
        e.stopPropagation();
        this.$router.push({name: 'create-moderate', params: {alias: asset.id}})
      },
      async loadAssets(type) {
        const filter = {
          populate: ['criteria', 'sectors'],
          limit: 5,
          type: type,
        };

        let paginator = await Services.Assets.fetchAssetsByFilter(filter);

        let sectorsToFetch = [];
        let criteriaToFetch = [];

        const assets = _.toArray(_.mapValues(paginator.items, asset => {
          sectorsToFetch = sectorsToFetch.concat(asset.sectors);
          criteriaToFetch = criteriaToFetch.concat(asset.criteria.map(c => c.criterion));
          return {
            _rowVariant: `row table-row--border-left`,
            ...asset
          }
        }));

        await this.fetchCriteria(_.uniq(criteriaToFetch));
        await this.fetchSectors(_.uniq(sectorsToFetch));

        return assets;
      }
    },
    computed: {
      ...mapGetters("settings", ["menuIsOpen"]),
      ...mapGetters('assets', {
        getAssetsByFilter: 'assetsByFilter',
        getCriterion: 'criterion',
        getCriteria: 'criteria',
        getSector: 'sector',
      }),
      flattenSector() {
        return (sectors, item) => {
          return sectors.map(s => {
            return this.getSector(s).title
          }).join(', ');
        }
      },
    },
    async beforeMount() {
      this.isLoaded = false;

      let pr = await Promise.all([this.loadAssets('crypto'), this.loadAssets('stock')])

      this.assets = pr[0];
      this.assetsStock = pr[1];
      this.isLoaded = true;

    },
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/assetsList/assetsList.vue